import { Router, NavigationEnd  } from '@angular/router';
import { HostListener, Directive,  ElementRef,  Input,  AfterViewInit } from '@angular/core';
import * as $ from "jquery";
import { StateService } from '../services/state.service';

@Directive({
  selector: '[appFullHeight]'
})
export class FullHeightDirective {

  originalLoggedIn = false;
  showMultipleOnMap = true;
  
  constructor(private el: ElementRef, private stateSvc: StateService, private router: Router) {
	// subscribe to URL address, track if any changes on URL
	this.router.events.subscribe((event:any) => {
		if (event instanceof NavigationEnd) {
			this.resizeContainerHeight();
		}
	});
	this.stateSvc.showMultipleOnMap
	.subscribe((result) => {
		this.showMultipleOnMap = result;
	});
  }
  
  ngAfterViewInit(): void {
	this.resizeContainerHeight();
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event) {
	this.resizeContainerHeight();
  }
  
  resizeContainerHeight(){
	//let availableHeight = $(window).innerHeight() - ($('.page-container').offset() || {}).top - $('.navbar-fixed-bottom').outerHeight();
	setTimeout(()=>{
		let availableHeight = $(window).innerHeight() - $('.navbar-static-top').outerHeight();
		if ($(window).innerWidth() <= 768) {
			availableHeight = availableHeight - 50;
		}
		this.el.nativeElement.style.minHeight = availableHeight + "px";
		if($('.sidebar-main .sidebar-content').outerHeight() < $(window).innerHeight()){
			$('.sidebar-main').height($(window).innerHeight() - 1);
			if($('.content-wrapper').outerHeight() > $(window).innerHeight()){
				$('.sidebar-main').height($('.content-wrapper').innerHeight() - 1);
			}
		}else{
			$('.sidebar-main').height($('.sidebar-main .sidebar-content').outerHeight());
		}
		$('.sidebar-secondary').height($('.sidebar-main').outerHeight());
		if ($(window).innerWidth() <= 768) {
			let adjHeight = 190;
			if(!this.showMultipleOnMap){
				adjHeight = 160;
			}
			$('.sidebar-secondary').height(adjHeight);
			$('.vehicle--summary').css('max-height',$('.vehicle--summary-list').outerHeight());
		}else{
			$('.vehicle--summary').css('max-height',$(window).innerHeight()-234);
		}
		$('.sidebar-third').height($('.sidebar-main').outerHeight());
		this.stateSvc.setwindowHeight($('.sidebar-main').innerHeight());
	},500);
  }

}
